import axios from "axios";
import lodash from "lodash";
import React from 'react';
import { injectIntl } from "react-intl";
import * as constants from "../../../util/constants";
import Alert from "../../common/Alert";
import ButtonSave from "../../common/ButtonSave";
import FieldCheckbox from "../../common/FieldCheckbox";
import FieldSelect from "../../common/FieldSelect";
import Propertii from "../../common/Propertii";

class Merchants extends Propertii {

    /**
     * Initialize the component.
     *
     * @param props - The properties of the component.
     */
    constructor(props) {

        super(props);

        this.state = {

            property: {},

            customMerchantAccounts: false,
            creditMerchantAccountList: {},
            paymentProcessor: null,

            validationList: [],

        };

        this.saveProperty = this.saveProperty.bind(this);
        this.handleChangeCreditMerchantAccount = this.handleChangeCreditMerchantAccount.bind(this);
    }

    /**
     * Fetch a new instance of a property object on the mounting of the component.
     */
    componentDidMount() {

        axios.get(`${constants.REACT_APP_HOST_API_URL}/property/${this.props.match.params.propertyId}`, {
            headers: this.generateRequestHeaders()
        }).then(response => {

            let companyId = response.data.companyId;
            let customMerchantAccounts = true;
            const paymentProviderId = response.data?.paymentProviderId;
            
            this.getMerchantAccounts(companyId,'TYPE_CREDIT_CARD', 'VISA', paymentProviderId);
            this.getMerchantAccounts(companyId,'TYPE_CREDIT_CARD', 'VISA_ELECTRON', paymentProviderId);
            this.getMerchantAccounts(companyId,'TYPE_CREDIT_CARD', 'MASTERCARD', paymentProviderId);
            this.getMerchantAccounts(companyId,'TYPE_CREDIT_CARD', 'MAESTRO', paymentProviderId);
            this.getMerchantAccounts(companyId,'TYPE_CREDIT_CARD', 'AMERICAN_EXPRESS', paymentProviderId);
            this.getMerchantAccounts(companyId,'TYPE_CREDIT_CARD', 'DISCOVER', paymentProviderId);
            this.getMerchantAccounts(companyId,'TYPE_CREDIT_CARD', 'DINERS_CLUB', paymentProviderId);
            this.getMerchantAccounts(companyId,'TYPE_CREDIT_CARD', 'JCB', paymentProviderId);
            this.getMerchantAccounts(companyId,'TYPE_CREDIT_CARD', 'UNION_PAY', paymentProviderId);
            this.getMerchantAccounts(companyId,'TYPE_BANK_ACCOUNT', null, paymentProviderId);
            this.getMerchantAccounts(companyId,'TYPE_PAY_PAL');
            this.getMerchantAccounts(companyId,'TYPE_CASH');
            this.getMerchantAccounts(companyId, null, null, paymentProviderId);

            if(response.data.bankMerchantAccountId === null
                && response.data.paypalMerchantAccountId === null
                && response.data.padMerchantAccountId === null
                && response.data.cashMerchantAccountId === null
                && response.data.splitItMerchantAccountId === null
                && Object.keys(response.data.creditMerchantAccountList).length === 0) {
                customMerchantAccounts = false;
            }

            this.setState(prevState => ({
                ...prevState,
                property: response.data,
                creditMerchantAccountList: response.data.creditMerchantAccountList,
                paymentProcessor: response.data?.paymentProviderId,
                customMerchantAccounts: customMerchantAccounts,
            }));

        }).catch(error => {
            this.handleValidation(error);
        });
    }

    /**
     * Handle the submission of the form.
     *
     * @param event - The event container.
     */
    saveProperty(event) {

        event.preventDefault();

        let property = this.state.property;

        property.creditMerchantAccountList = this.state.creditMerchantAccountList;

        Object.entries(property.creditMerchantAccountList).forEach(([key, value]) => {
            if(value === '' || !this.state.customMerchantAccounts) {
                delete property.creditMerchantAccountList[key];
            }
        });

        if(!this.state.customMerchantAccounts) {
            property.creditMerchantAccountList = null;
            property.bankMerchantAccountId = null;
            property.paypalMerchantAccountId = null;
            property.cashMerchantAccountId = null;
            property.padMerchantAccountId = null;
            property.splitItMerchantAccountId = null;
        }
        
        const paymentProcessor = this.state.paymentProcessor;
        property.rmProviderSummary.providerMap[paymentProcessor] = {
            creditMerchantAccountList:  lodash.cloneDeep(property.creditMerchantAccountList),
            bankMerchantAccountId:  lodash.cloneDeep(property.bankMerchantAccountId),
            padMerchantAccountId:  lodash.cloneDeep(property.padMerchantAccountId),
            splitItMerchantAccountId: lodash.cloneDeep(property.splitItMerchantAccountId),
        }

        axios.put(`${constants.REACT_APP_HOST_API_URL}/update`, property, {
            headers: this.generateRequestHeaders()
        }).then(response => {
            this.setState({
                validationList: [{
                    fields: {},
                    alert: {
                        type: 'primary',
                        code: 'saved',
                        message: 'Changes have been saved'
                    }
                }],
            });
        }).catch(error => {
            this.handleValidation(error);
        });

        window.scrollTo(0, 0);
    }

    /**
     * Handle changes to the default credit/debit merchant account field. By selecting a merchant account from this
     * field, the same merchant account will be applies to all credit/debit card brands available.
     *
     * @param event - The event container.
     */
    handleChangeCreditMerchantAccount(event) {

        event.preventDefault();

        let creditMerchantAccountList = this.state.creditMerchantAccountList;
        let creditMerchantAccountId = event.target.value;

        creditMerchantAccountList['VISA'] = creditMerchantAccountId;
        creditMerchantAccountList['VISA_ELECTRON'] = creditMerchantAccountId;
        creditMerchantAccountList['MASTERCARD'] = creditMerchantAccountId;
        creditMerchantAccountList['MAESTRO'] = creditMerchantAccountId;
        creditMerchantAccountList['AMERICAN_EXPRESS'] = creditMerchantAccountId;
        creditMerchantAccountList['DISCOVER'] = creditMerchantAccountId;
        creditMerchantAccountList['DINERS_CLUB'] = creditMerchantAccountId;
        creditMerchantAccountList['JCB'] = creditMerchantAccountId;

        this.setState(prevState => ({
            ...prevState,
            creditMerchantAccountList: creditMerchantAccountList,
        }));
    }

    /**
     * Render the component.
     *
     * @returns {*} - The edit property address component for managers.
     */
    render() {

        const {formatMessage} = this.props.intl;

        return(
            <React.Fragment>

                <Alert validationList={this.state.validationList} />

                <form onSubmit={this.saveProperty}>

                    <div className="card card-primary border-primary">
                        <div className="card-body">
                            <p className="card-text">
                                Merchant accounts determine where funds should be sent to when your tenants make payments. By default, all funds are sent to your company's default merchant accounts. This can be overridden by assigning custom merchant accounts specifically to this property using the form below.
                            </p>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-header">
                            Merchant Accounts
                        </div>
                        <div className="card-body">

                            <FieldCheckbox id="customMerchantAccounts" label="Merchant Accounts" fieldLabel="This property utilizes custom merchant accounts" parent={this} value={this.state.customMerchantAccounts} />

                            {this.state.customMerchantAccounts &&
                            <div className="">

                                {this.state.property.creditMerchantAccountList &&
                                    <FieldSelect id="VISA" label="Credit/Debit Card" model="creditMerchantAccountList" parent={this} help="Applies to Visa, Visa Electron, Mastercard, Maestro, American Express, Discover, Diners Club, and JCB cards." value={this.state.creditMerchantAccountList['VISA']} handleChange={this.handleChangeCreditMerchantAccount}>
                                        {this.state.visaMerchantAccounts &&
                                        <React.Fragment>
                                            {this.state.visaMerchantAccounts.map((data, key) => {
                                                if(data.id === data.joins.c.creditMerchantAccountList['VISA']) {
                                                    return (<option key={key} value={this.state.creditMerchantAccountList['VISA'] === undefined || this.state.creditMerchantAccountList['VISA'] === null ? "" : data.id}>[DEFAULT] {data.accountNumber ? data.accountNumber + ' — ' : ''}{data.name ? data.name + ' — ' : ''}{data.last4 ? '*****' + data.last4 + ' — ' : ''}{formatMessage({id: "enum.merchantAccount.accountStatus." + data.accountStatus})}</option>);
                                                } else {
                                                    return (<option key={key} value={data.id}>[{data.paymentProviderId?.split('_')[0]}] {data.accountNumber ? data.accountNumber + ' — ' : ''}{data.name ? data.name + ' — ' : ''}{data.last4 ? '*****' + data.last4 + ' — ' : ''}{formatMessage({id: "enum.merchantAccount.accountStatus." + data.accountStatus})}</option>);
                                                }
                                            })}
                                            <option value="">-</option>
                                        </React.Fragment>
                                        }
                                    </FieldSelect>
                                }

                                <FieldSelect id="bankMerchantAccountId" label="Bank Account" model="property" parent={this} value={this.state.property['bankMerchantAccountId']}>
                                    {this.state.bankMerchantAccounts &&
                                    <React.Fragment>
                                        {this.state.bankMerchantAccounts.map((data, key) => {
                                            if(data.id === data.joins.c.bankMerchantAccountId) {
                                                return (<option key={key} value={this.state.property['bankMerchantAccountId'] === undefined || this.state.property['bankMerchantAccountId'] === null ? "" : data.id}>[DEFAULT] {data.accountNumber ? data.accountNumber + ' — ' : ''}{data.name ? data.name + ' — ' : ''}{data.last4 ? '*****' + data.last4 + ' — ' : ''}{formatMessage({id: "enum.merchantAccount.accountStatus." + data.accountStatus})}</option>);
                                            } else {
                                                return (<option key={key} value={data.id}>[{data.paymentProviderId?.split('_')[0]}] {data.accountNumber ? data.accountNumber + ' — ' : ''}{data.name ? data.name + ' — ' : ''}{data.last4 ? '*****' + data.last4 + ' — ' : ''}{formatMessage({id: "enum.merchantAccount.accountStatus." + data.accountStatus})}</option>);
                                            }
                                        })}
                                        <option value="">-</option>
                                    </React.Fragment>
                                    }
                                </FieldSelect>
                                
                                {this.state.property.creditMerchantAccountList &&
                                    <FieldSelect id="UNION_PAY" label="UnionPay" model="creditMerchantAccountList" parent={this} value={this.state.creditMerchantAccountList['UNION_PAY']}>
                                        {this.state.unionPayMerchantAccounts &&
                                        <React.Fragment>
                                            {this.state.unionPayMerchantAccounts.map((data, key) => {
                                                if(data.id === data.joins.c.creditMerchantAccountList['UNION_PAY']) {
                                                    return (<option key={key} value={this.state.creditMerchantAccountList['UNION_PAY'] === undefined || this.state.creditMerchantAccountList['UNION_PAY'] === null ? "" : data.id}>[DEFAULT] {data.accountNumber ? data.accountNumber + ' — ' : ''}{data.name ? data.name + ' — ' : ''}{data.last4 ? '*****' + data.last4 + ' — ' : ''}{formatMessage({id: "enum.merchantAccount.accountStatus." + data.accountStatus})}</option>);
                                                } else {
                                                    return (<option key={key} value={data.id}>{data.accountNumber ? data.accountNumber + ' — ' : ''}{data.name ? data.name + ' — ' : ''}{data.last4 ? '*****' + data.last4 + ' — ' : ''}{formatMessage({id: "enum.merchantAccount.accountStatus." + data.accountStatus})}</option>);
                                                }
                                            })}
                                            <option value="">-</option>
                                        </React.Fragment>
                                        }
                                    </FieldSelect>
                                }

                                <FieldSelect id="paypalMerchantAccountId" label="PayPal" model="property" parent={this} value={this.state.property['paypalMerchantAccountId']}>
                                    {this.state.paypalMerchantAccounts &&
                                    <React.Fragment>
                                        {this.state.paypalMerchantAccounts.map((data, key) => {
                                            if(data.id === data.joins.c.paypalMerchantAccountId) {
                                                return (<option key={key} value={this.state.property['paypalMerchantAccountId'] === undefined || this.state.property['paypalMerchantAccountId'] === null ? "" : data.id}>[DEFAULT] {data.accountNumber ? data.accountNumber + ' — ' : ''}{data.name ? data.name + ' — ' : ''}{data.last4 ? '*****' + data.last4 + ' — ' : ''}{formatMessage({id: "enum.merchantAccount.accountStatus." + data.accountStatus})}</option>);
                                            } else {
                                                return (<option key={key} value={data.id}>[{data.paymentProviderId?.split('_')[0]}] {data.accountNumber ? data.accountNumber + ' — ' : ''}{data.name ? data.name + ' — ' : ''}{data.last4 ? '*****' + data.last4 + ' — ' : ''}{formatMessage({id: "enum.merchantAccount.accountStatus." + data.accountStatus})}</option>);
                                            }
                                        })}
                                        <option value="">-</option>
                                    </React.Fragment>
                                    }
                                </FieldSelect>

                                <FieldSelect id="cashMerchantAccountId" label="Cash" model="property" parent={this} value={this.state.property['cashMerchantAccountId']}>
                                    {this.state.cashMerchantAccounts &&
                                    <React.Fragment>
                                        {this.state.cashMerchantAccounts.map((data, key) => {
                                            if(data.id === data.joins.c.cashMerchantAccountId) {
                                                return (<option key={key} value={this.state.property['cashMerchantAccountId'] === undefined || this.state.property['cashMerchantAccountId'] === null ? "" : data.id}>[DEFAULT] {data.accountNumber ? data.accountNumber + ' — ' : ''}{data.name ? data.name + ' — ' : ''}{data.last4 ? '*****' + data.last4 + ' — ' : ''}{formatMessage({id: "enum.merchantAccount.accountStatus." + data.accountStatus})}</option>);
                                            } else {
                                                return (<option key={key} value={data.id}>[{data.paymentProviderId?.split('_')[0]}] {data.accountNumber ? data.accountNumber + ' — ' : ''}{data.name ? data.name + ' — ' : ''}{data.last4 ? '*****' + data.last4 + ' — ' : ''}{formatMessage({id: "enum.merchantAccount.accountStatus." + data.accountStatus})}</option>);
                                            }
                                        })}
                                        <option value="">-</option>
                                    </React.Fragment>
                                    }
                                </FieldSelect>

                                <FieldSelect id="padMerchantAccountId" label="Pre-Authorized Debit" model="property" parent={this} value={this.state.property['padMerchantAccountId']}>
                                    {this.state.padMerchantAccounts &&
                                    <React.Fragment>
                                        {this.state.padMerchantAccounts.map((data, key) => {
                                            if(data.id === data.joins.c.padMerchantAccountId) {
                                                return (<option key={key} value={this.state.property['padMerchantAccountId'] === undefined || this.state.property['padMerchantAccountId'] === null ? "" : data.id}>[DEFAULT] {data.accountNumber ? data.accountNumber + ' — ' : ''}{data.name ? data.name + ' — ' : ''}{data.last4 ? '*****' + data.last4 + ' — ' : ''}{formatMessage({id: "enum.merchantAccount.accountStatus." + data.accountStatus})}</option>);
                                            } else {
                                                return (<option key={key} value={data.id}>[{data.paymentProviderId?.split('_')[0]}] {data.accountNumber ? data.accountNumber + ' — ' : ''}{data.name ? data.name + ' — ' : ''}{data.last4 ? '*****' + data.last4 + ' — ' : ''}{formatMessage({id: "enum.merchantAccount.accountStatus." + data.accountStatus})}</option>);
                                            }
                                        })}
                                        <option value="">-</option>
                                    </React.Fragment>
                                    }
                                </FieldSelect>

                                <FieldSelect id="splitItMerchantAccountId" label="SplitIt" model="property" parent={this} value={this.state.property['splitItMerchantAccountId']}>
                                {this.state.bankMerchantAccounts &&
                                    <React.Fragment>
                                        {this.state.bankMerchantAccounts.map((data, key) => {
                                            if(data.id === data.joins.c.splitItMerchantAccountId) {
                                                return (<option key={key} value={this.state.property['splitItMerchantAccountId'] === undefined || this.state.property['splitItMerchantAccountId'] === null ? "" : data.id}>[DEFAULT] {data.accountNumber ? data.accountNumber + ' — ' : ''}{data.name ? data.name + ' — ' : ''}{data.last4 ? '*****' + data.last4 + ' — ' : ''}{formatMessage({id: "enum.merchantAccount.accountStatus." + data.accountStatus})}</option>);
                                            } else {
                                                return (<option key={key} value={data.id}>[{data.paymentProviderId?.split('_')[0]}] {data.accountNumber ? data.accountNumber + ' — ' : ''}{data.name ? data.name + ' — ' : ''}{data.last4 ? '*****' + data.last4 + ' — ' : ''}{formatMessage({id: "enum.merchantAccount.accountStatus." + data.accountStatus})}</option>);
                                            }
                                        })}
                                        <option value="">-</option>
                                    </React.Fragment>
                                    }
                                </FieldSelect>

                            </div>
                            }

                        </div>
                    </div>


                    <div className="row">
                        <div className="col text-right">

                            <ButtonSave />

                        </div>
                    </div>

                </form>

            </React.Fragment>
        )
    };
}

export default injectIntl(Merchants);